import PropTypes from 'prop-types';

const InstructorCardProps = {
  position: PropTypes.shape({
    title: PropTypes.string,
    organizationName: PropTypes.string,
  }),
  profileImageUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  classList: PropTypes.string,
  tracking: PropTypes.shape(),
  givenName: PropTypes.string,
  familyName: PropTypes.string,
};

export default InstructorCardProps;
